import React from 'react';
import PropType from 'prop-types';
import { StyledIconSizing, StyledIconContainer } from './SVGIcon.styles';

/** Icon imports */
import Airport from './icons/Airport';
import Amex from './icons/Amex';
import ArrowFilled from './icons/ArrowFilled';
import ArrowIcon from './icons/ArrowIcon';
import ArrowDouble from './icons/ArrowDouble';
import Australia from './icons/Australia';
import BookingChange from './icons/BookingChange';
import BookingFilter from './icons/BookingFilter';
import Buildings from './icons/Buildings';
import Bed from './icons/Bed';
import CircleCurrencyDollar from './icons/CircleCurrencyDollar';
import Coins from './icons/Coins';
import ChargeSheetSummary from './icons/ChargeSheetSummary';
import MarginsEmpty from './icons/MarginsEmpty';
import Bookmark from './icons/Bookmark';
import DashboardCrews from './icons/DashboardCrews';
import Calendar from './icons/Calendar';
import Canada from './icons/Canada';
import CardViewToggle from './icons/CardViewToggle';
import CarouselIcon from './icons/CarouselIcon';
import Checkbox from './icons/Checkbox';
import CheckboxUnchecked from './icons/CheckboxUnchecked';
import Checkmark from './icons/Checkmark';
import ClearSearch from './icons/ClearSearch';
import Close from './icons/Close';
import CloseModal from './icons/CloseModal';
import ClosePanel from './icons/ClosePanel';
import Collapse from './icons/Collapse';
import Construction from './icons/Construction';
import Crew from './icons/Crew';
import Crews from './icons/Crews';
import CrewSupervisor from './icons/CrewSupervisor';
import Directions from './icons/Directions';
import Download from './icons/Download';
import DraggableRow from './icons/DraggableRow';
import Education from './icons/Education';
import Ellipsis from './icons/Ellipsis';
import Emergency from './icons/Emergency';
import Expand from './icons/Expand';
import DrillingRig from './icons/DrillingRig';
import Facebook from './icons/Facebook';
import Facitilies from './icons/Facilities';
import Favourite from './icons/Favourite';
import Forestry from './icons/Forestry';
import FuelStation from './icons/FuelStation';
import Government from './icons/Government';
import Hamburger from './icons/Hamburger';
import HotelIcon from './icons/HotelIcon';
import Info from './icons/Info';
import LinkIcon from './icons/Link';
import LinkedIn from './icons/LinkedIn';
import LodgeLinkLogoColor from './icons/LodgeLinkLogoColor';
import LodegLinkLogoWhite from './icons/LodgeLinkLogoWhite';
import LodegLinkLogoDemo from './icons/LodgeLinkLogoDemo';
import MapGrid from './icons/MapGrid';
import MapLayers from './icons/MapLayers';
import Mastercard from './icons/Mastercard';
import MissingDetails from './icons/MissingDetails';
import Mining from './icons/Mining';
import Money from './icons/Money';
import NightShiftIcon from './icons/NightShift';
import Notifications from './icons/Notifications';
import NoSearchResults from './icons/NoSearchResults';
import OrganizationSettings from './icons/OrganizationSettings';
import OilGas from './icons/OilGas';
import OneStopShopOne from './icons/OneStopShopOne';
import OneStopShopTwo from './icons/OneStopShopTwo';
import OneStopShopThree from './icons/OneStopShopThree';
import OpenPanel from './icons/OpenPanel';
import Padlock from './icons/Padlock';
import Paperwork from './icons/Paperwork';
import Phone from './icons/Phone';
import Pencil from './icons/Pencil';
import PhoneNotification from './icons/PhoneNotification';
import Pin from './icons/Pin';
import Pipeline from './icons/Pipeline';
import ProjectSite from './icons/ProjectSite';
import Projects from './icons/Projects';
import Quote from './icons/Quote';
import Radio from './icons/Radio';
import Redo from './icons/Redo';
import RoomsEmpty from './icons/RoomsEmpty';
import Schools from './icons/Schools';
import SearchArrow from './icons/SearchArrow';
import SearchIcon from './icons/SearchIcon';
import Settings from './icons/Settings';
import Share from './icons/Share';
import SharedRoom from './icons/SharedRoom';
import Star from './icons/Star';
import TableViewToggle from './icons/TableViewToggle';
import Transportation from './icons/Transportation';
import Trash from './icons/Trash';
import Twitter from './icons/Twitter';
import USA from './icons/USA';
import Utilities from './icons/Utilities';
import UWIIcon from './icons/UWIIcon';
import Visa from './icons/Visa';
import Warning from './icons/Warning';
import ColoredWarning from './icons/ColoredWarning';
import YouTube from './icons/YouTube';
import SupplierFeatureOne from './icons/SupplierFeatureOne';
import SupplierFeatureTwo from './icons/SupplierFeatureTwo';
import SupplierFeatureThree from './icons/SupplierFeatureThree';
import Instagram from './icons/Instagram';
import ZoomInIcon from './icons/ZoomIn';
import ZoomOutIcon from './icons/ZoomOut';
import EditPencil from './icons/EditPencil';
import Activate from './icons/Activate';
import UploadToCloud from './icons/UploadToCloud';

/** Amenity Icon imports */
import Bar from './amenity-icons/Bar';
import Washing from './amenity-icons/Washing';
import RoomService from './amenity-icons/RoomService';
import Fridge from './amenity-icons/Fridge';
import Tv from './amenity-icons/Tv';
import Internet from './amenity-icons/Internet';
import Air from './amenity-icons/Air';
import Cafe from './amenity-icons/Cafe';
import Parking from './amenity-icons/Parking';
import BagLunch from './amenity-icons/BagLunch';
import VendingMachine from './amenity-icons/VendingMachine';
import Medic from './amenity-icons/Medic';
import PoweredParking from './amenity-icons/PoweredParking';
import ConvenienceStore from './amenity-icons/ConvenienceStore';
import GamesRoom from './amenity-icons/GamesRoom';
import TwoOccupant from './amenity-icons/TwoOccupant';
import AfterHourMeal from './amenity-icons/AfterHourMeal';
import LargeParking from './amenity-icons/LargeParking';
import BagStorage from './amenity-icons/BagStorage';
import PrivateWashroom from './amenity-icons/PrivateWashroom';
import Restaurant from './amenity-icons/Restaurant';
import Security from './amenity-icons/Security';
import Salon from './amenity-icons/Salon';
import Fitness from './amenity-icons/Fitness';
import Chiropractor from './amenity-icons/Chiropractor';
import Massage from './amenity-icons/Massage';
import Breakfast from './amenity-icons/Breakfast';
import MeetingRoom from './amenity-icons/MeetingRoom';
import ArcticHalls from './amenity-icons/ArcticHalls';
import ATM from './amenity-icons/ATM';
import Dinner from './amenity-icons/Dinner';
import Pool from './amenity-icons/Pool';
import SharedWashroom from './amenity-icons/SharedWashroom';
import Kitchenette from './amenity-icons/Kitchenette';
import RotateLeft from './icons/RotateLeft';
import RotateRight from './icons/RotateRight';
import PetFriendly from './amenity-icons/PetFriendly';
import TrashBin from './icons/TrashBin';

/* Status Icons */
import WarningArgyle from './StatusIcons/WarningArgyle';
import WarningCircle from './StatusIcons/WarningCircle';
import Success from './StatusIcons/Success';
import Information from './StatusIcons/Information';
import Guidance from './StatusIcons/Guidance';

/** Add SVG Icons here */
const iconIndex = (props) => {
  const {
    width,
    height,
    iconColor,
    backgroundColor,
    backgroundColor2,
    iconRed1,
    iconRed2,
    iconBlue,
    onClick,
    iconColor1,
    iconColor2,
    iconColor3,
    iconColor4,
    iconColor5,
    iconStripes,
    iconStarBackground,
    stripeSeperatorColor
  } = props;

  return {
    amex: <Amex height={height} width={width} />,
    arrow: <ArrowIcon height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    arrowFill: <ArrowFilled height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    arrowDouble: <ArrowDouble height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    australia: (
      <Australia
        height={height}
        width={width}
        backgroundColor={backgroundColor}
        backgroundColor2={backgroundColor2}
        iconRed1={iconRed1}
        iconRed2={iconRed2}
        iconBlue={iconBlue}
      />
    ),
    bookmark: <Bookmark height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    'booking-change': <BookingChange height={height} width={width} iconColor={iconColor} />,
    bookingFilter: <BookingFilter height={height} width={width} iconColor={iconColor} />,
    buildings: <Buildings height={height} width={width} iconColor={iconColor} />,
    bed: <Bed height={height} width={width} iconColor={iconColor} />,
    circleCurrencyDollar: <CircleCurrencyDollar height={height} width={width} iconColor={iconColor} />,
    coins: <Coins height={height} width={width} iconColor={iconColor} />,
    chargeSheetSummary: <ChargeSheetSummary height={height} width={width} iconColor={iconColor} />,
    calendar: <Calendar height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    canada: <Canada height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    cardViewToggle: <CardViewToggle height={height} width={width} iconColor={iconColor} />,
    carousel: <CarouselIcon height={height} width={width} iconColor={iconColor} />,
    checkbox: <Checkbox height={height} width={width} iconColor={iconColor} />,
    checkboxUnchecked: <CheckboxUnchecked height={height} width={width} iconColor={iconColor} />,
    checkmark: <Checkmark height={height} width={width} iconColor={iconColor} />,
    close: <Close height={height} width={width} iconColor={iconColor} />,
    closeModal: (
      <CloseModal
        height={height}
        width={width}
        iconColor={iconColor}
        backgroundColor={backgroundColor}
        onClick={onClick}
      />
    ),
    closePanel: <ClosePanel height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    collapse: <Collapse height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    'clear-search': <ClearSearch height={height} width={width} iconColor={iconColor} />,
    construction: (
      <Construction height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    crew: <Crew height={height} width={width} iconColor={iconColor} />,
    crews: <Crews height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    crewSupervisor: <CrewSupervisor height={height} width={width} />,
    'dashboard-crews': <DashboardCrews height={height} width={width} iconColor={iconColor} />,
    directions: <Directions height={height} width={width} iconColor={iconColor} />,
    draggableRow: <DraggableRow height={height} width={width} iconColor={iconColor} />,
    download: <Download height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    education: <Education height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    ellipsis: <Ellipsis height={height} width={width} iconColor={iconColor} />,
    emergency: <Emergency height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    expand: <Expand height={height} width={width} iconColor={iconColor} />,
    facebook: <Facebook height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    favourite: <Favourite height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    facilities: <Facitilies height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    forestry: <Forestry height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    government: <Government height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    hamburger: <Hamburger height={height} width={width} iconColor={iconColor} />,
    hotel: <HotelIcon height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    info: <Info height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    link: <LinkIcon height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    linkedin: <LinkedIn height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    lodgelinkcolor: (
      <LodgeLinkLogoColor
        height={height}
        width={width}
        backgroundColor={backgroundColor}
        iconColor1={iconColor1}
        iconColor2={iconColor2}
        iconColor3={iconColor3}
        iconColor4={iconColor4}
      />
    ),
    lodgelinkwhite: (
      <LodegLinkLogoWhite height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    lodgelinkdemo: (
      <LodegLinkLogoDemo
        height={height}
        width={width}
        backgroundColor={backgroundColor}
        iconColor1={iconColor1}
        iconColor2={iconColor2}
        iconColor3={iconColor3}
        iconColor4={iconColor4}
        iconColor5={iconColor5}
      />
    ),
    'map-grid': <MapGrid height={height} width={width} iconColor={iconColor} />,
    marginsEmpty: <MarginsEmpty height={height} width={width} iconColor={iconColor} />,
    mastercard: <Mastercard height={height} width={width} />,
    missingDetails: <MissingDetails height={height} width={width} />,
    mining: <Mining height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    money: <Money height={height} width={width} iconColor={iconColor} />,
    nightShift: <NightShiftIcon height={height} width={width} iconColor={iconColor} />,
    notifications: (
      <Notifications height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    noSearchResults: <NoSearchResults height={height} width={width} />,
    'organization-settings': <OrganizationSettings height={height} width={width} iconColor={iconColor} />,
    oilgas: <OilGas height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    'one-stop-shop-one': <OneStopShopOne height={height} width={width} />,
    'one-stop-shop-two': <OneStopShopTwo height={height} width={width} />,
    'one-stop-shop-three': <OneStopShopThree height={height} width={width} />,
    openPanel: <OpenPanel height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    paperwork: <Paperwork height={height} width={width} iconColor={iconColor} />,
    padlock: <Padlock height={height} width={width} iconColor={iconColor} />,
    pencil: <Pencil height={height} width={width} iconColor={iconColor} />,
    pin: <Pin height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    pipeline: <Pipeline height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    phone: <Phone height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    'phone-notification': <PhoneNotification height={height} width={width} iconColor={iconColor} />,
    projects: <Projects height={height} width={width} />,
    quote: <Quote height={height} width={width} iconColor={iconColor} />,
    'map-layers': <MapLayers height={height} width={width} iconColor={iconColor} />,
    radio: <Radio height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    redo: <Redo height={height} width={width} iconColor={iconColor} />,
    rotateLeft: <RotateLeft height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    roomsEmpty: <RoomsEmpty height={height} width={width} iconColor={iconColor} />,
    rotateRight: <RotateRight height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    airport: <Airport height={height} width={width} iconColor={iconColor} />,
    project: <ProjectSite height={height} width={width} iconColor={iconColor} />,
    drill: <DrillingRig height={height} width={width} iconColor={iconColor} />,
    fuel: <FuelStation height={height} width={width} iconColor={iconColor} />,
    search: <SearchIcon height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    searchArrow: <SearchArrow height={height} width={width} iconColor={iconColor} />,
    share: <Share height={height} width={width} iconColor={iconColor} />,
    settings: <Settings height={height} width={width} iconColor={iconColor} />,
    schools: <Schools height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    sharedRoom: <SharedRoom height={height} width={width} iconColor={iconColor} />,
    star: <Star height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    tableViewToggle: <TableViewToggle height={height} width={width} iconColor={iconColor} />,
    transportation: (
      <Transportation height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    trashBin: <TrashBin height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    trash: <Trash height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    twitter: <Twitter height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    usa: (
      <USA
        height={height}
        width={width}
        iconColor={iconColor}
        backgroundColor={backgroundColor}
        backgroundColor2={backgroundColor2}
        iconStripes={iconStripes}
        iconStarBackground={iconStarBackground}
        stripeSeperatorColor={stripeSeperatorColor}
      />
    ),
    uploadToCloud: <UploadToCloud height={height} width={width} iconColor={iconColor} />,
    utilities: <Utilities height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    uwi: <UWIIcon height={height} width={width} iconColor={iconColor} />,
    visa: <Visa height={height} width={width} />,
    youtube: <YouTube height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    warning: <Warning height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    coloredWarning: (
      <ColoredWarning height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    'supplier-feature-one': (
      <SupplierFeatureOne height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    'supplier-feature-two': (
      <SupplierFeatureTwo height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    'supplier-feature-three': (
      <SupplierFeatureThree height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />
    ),
    instagram: <Instagram height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    zoomIn: <ZoomInIcon height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    zoomOut: <ZoomOutIcon height={height} width={width} iconColor={iconColor} backgroundColor={backgroundColor} />,
    editPencil: <EditPencil height={height} width={width} iconColor={iconColor} />,
    activate: <Activate height={height} width={width} iconColor={iconColor} />
  };
};

/** Add SVG Icons here */
const amenityIconIndex = (props) => {
  const { height, width, iconColor } = props;

  return {
    bar: <Bar height={height} width={width} iconColor={iconColor} />,
    washing: <Washing height={height} width={width} iconColor={iconColor} />,
    roomservice: <RoomService height={height} width={width} iconColor={iconColor} />,
    fridge: <Fridge height={height} width={width} iconColor={iconColor} />,
    tv: <Tv height={height} width={width} iconColor={iconColor} />,
    internet: <Internet height={height} width={width} iconColor={iconColor} />,
    air: <Air height={height} width={width} iconColor={iconColor} />,
    cafe: <Cafe height={height} width={width} iconColor={iconColor} />,
    parking: <Parking height={height} width={width} iconColor={iconColor} />,
    baglunch: <BagLunch height={height} width={width} iconColor={iconColor} />,
    vendingmachine: <VendingMachine height={height} width={width} iconColor={iconColor} />,
    medic: <Medic height={height} width={width} iconColor={iconColor} />,
    poweredparking: <PoweredParking height={height} width={width} iconColor={iconColor} />,
    conveniencestore: <ConvenienceStore height={height} width={width} iconColor={iconColor} />,
    gamesroom: <GamesRoom height={height} width={width} iconColor={iconColor} />,
    twooccupant: <TwoOccupant height={height} width={width} iconColor={iconColor} />,
    afterhourmeal: <AfterHourMeal height={height} width={width} iconColor={iconColor} />,
    largeparking: <LargeParking height={height} width={width} iconColor={iconColor} />,
    bagstorage: <BagStorage height={height} width={width} iconColor={iconColor} />,
    privatewashroom: <PrivateWashroom height={height} width={width} iconColor={iconColor} />,
    restaurant: <Restaurant height={height} width={width} iconColor={iconColor} />,
    '24hsecurity': <Security height={height} width={width} iconColor={iconColor} />,
    salon: <Salon height={height} width={width} iconColor={iconColor} />,
    fitness: <Fitness height={height} width={width} iconColor={iconColor} />,
    chiropractor: <Chiropractor height={height} width={width} iconColor={iconColor} />,
    massage: <Massage height={height} width={width} iconColor={iconColor} />,
    breakfast: <Breakfast height={height} width={width} iconColor={iconColor} />,
    meetingroom: <MeetingRoom height={height} width={width} iconColor={iconColor} />,
    arctichalls: <ArcticHalls height={height} width={width} iconColor={iconColor} />,
    atm: <ATM height={height} width={width} iconColor={iconColor} />,
    dinner: <Dinner height={height} width={width} iconColor={iconColor} />,
    pool: <Pool height={height} width={width} iconColor={iconColor} />,
    sharedwashroom: <SharedWashroom height={height} width={width} iconColor={iconColor} />,
    kitchenette: <Kitchenette height={height} width={width} iconColor={iconColor} />,
    petfriendly: <PetFriendly height={height} width={width} iconColor={iconColor} />
  };
};

const statusIconIndex = (props) => {
  const { height, width } = props;

  return {
    information: <Information height={height} width={width} />,
    guidance: <Guidance height={height} width={width} />,
    success: <Success height={height} width={width} />,
    warningArgyle: <WarningArgyle height={height} width={width} />,
    warningCircle: <WarningCircle height={height} width={width} />
  };
};

export const iconIndexKeys = Object.keys(iconIndex({}));
export const amenityIconIndexKeys = Object.keys(amenityIconIndex({}));
export const statusIconIndexKeys = Object.keys(statusIconIndex({}));

function SVGIcon(props) {
  const {
    selectedIcon,
    height,
    width,
    rotate,
    className,
    onClick,
    backgroundColor,
    iconColor,
    'data-testid': testId
  } = props;
  const icon =
    iconIndex({ selectedIcon, height, width, rotate, className, onClick, backgroundColor, iconColor })[selectedIcon] ||
    amenityIconIndex({ selectedIcon, height, width, rotate, className, onClick, backgroundColor, iconColor })[
      selectedIcon
    ] ||
    statusIconIndex({ selectedIcon, height, width })[selectedIcon];

  let iconWidth;
  let iconHeight;
  let iconPadding;

  if (icon) {
    const {
      props: { width: propIconWidth, height: propIconHeight }
    } = icon;
    iconPadding = (propIconWidth && propIconHeight) !== undefined ? (propIconHeight / propIconWidth) * 100 : 100;
    iconWidth = propIconWidth !== undefined ? `${propIconWidth}px` : '';
    iconHeight = propIconHeight !== undefined ? `${propIconHeight}px` : '';
  }

  // overrides the icon padding based on the passed props for height and width if both are passed.
  if (height && width) iconPadding = (height.replace('px', '') / width.replace('px', '')) * 100;

  // overrides the height to auto if a percent is passed to the width
  const heightAuto = width ? width.indexOf('%') > -1 : false;

  return (
    <StyledIconSizing
      data-testid={testId}
      width={!width ? `${iconWidth}` : width}
      height={!height ? `${iconHeight}` : height}
      className={className}
      heightAuto={heightAuto}
      onClick={onClick}
    >
      <StyledIconContainer rotate={rotate} iconPadding={iconPadding}>
        {icon || null}
      </StyledIconContainer>
    </StyledIconSizing>
  );
}

SVGIcon.propTypes = {
  /**
   * The Selected SVG Icon
   */
  selectedIcon: PropType.string.isRequired,

  /**
   * Selected background color, all SVGs have a default color related to their branding
   */
  backgroundColor: PropType.string,

  /**
   * The height of the Icon if different from the default - including unit (px, % etc.)
   */
  height: PropType.string,

  /**
   * The width of the Icon if different from the default - including unit (px, % etc.)
   */
  width: PropType.string,

  /**
   * The Icons color, most default to white
   */
  iconColor: PropType.string,

  /**
   * Rotation of the Icon, passed as a number between 0-360
   */
  rotate: PropType.number,

  /**
   * Option to take in a click function on the SVG
   */
  onClick: PropType.func,

  /**
   * Add ability to override in .styles.js file
   */
  className: PropType.string,
  'data-testid': PropType.string
};

SVGIcon.defaultProps = {
  backgroundColor: undefined,
  height: undefined,
  width: undefined,
  iconColor: undefined,
  rotate: 0,
  onClick: undefined,
  className: null,
  'data-testid': ''
};

export default SVGIcon;
